
export default function ContentHeader(props){
    return(
        
         <section className="card-header">
                <h1>{props.title}</h1>
            </section>
       
    )
}